import { render, staticRenderFns } from "./miniDialog.vue?vue&type=template&id=fe573a32&scoped=true&"
import script from "./miniDialog.vue?vue&type=script&lang=js&"
export * from "./miniDialog.vue?vue&type=script&lang=js&"
import style0 from "./miniDialog.vue?vue&type=style&index=0&id=fe573a32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe573a32",
  null
  
)

export default component.exports